import TimeSpent from "./TimeSpent";

export default TimeSpent;
